export default {"src":"/_next/static/media/googlePlay.6853b440.svg","height":56,"width":168,"blurWidth":0,"blurHeight":0};